export const getFileExtension = (filename: string) => {
  if (!filename) { return ''; }

  const dotIndex = filename.lastIndexOf('.');
  return dotIndex === -1 ? '' : filename.slice(dotIndex + 1);
};

export const getFileType = (extension: string) => {
  switch (extension) {
    case "png":
    case "jpg":
    case "jpeg":
    case "tiff":
    case "heic":
    case "gif":
    case "webp":
    case "avif":
      return "IMAGE";
    case "xlsx":
    case "csv":
      return "SHEET";
    case "mov":
      return "VIDEO";
    case "mp3":
    case "mpeg":
    case "wav":
      return "AUDIO";
    case "docx":
    case "doc":
    case "pdf":
      return "DOC";
    case "zip":
      return "ZIP";
    default:
      return null;
  }
};
